import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  pbRoot: {
    "& p": {
      fontSize: theme.typography.body2.fontSize,
      lineHeight: theme.spacing(0.3)
    }
  },

  pbBio: {
    fontSize: theme.typography.body1.fontSize,
    lineHeight: theme.spacing(0.3),
    marginBottom: theme.spacing(2)
  },

  pbSignoutContainer: {
    margin: theme.spacing(3, 0),
    "& span": {
      width: "100%",
      fontSize: theme.typography.body2.fontSize,
      fontWeight: theme.typography.fontWeightBold,
      textAlign: "center",
      lineHeight: theme.spacing(0.3),
      color: theme.palette.extras.red,
      cursor: "pointer"
    }
  }
}));
